import { demoFile, feature } from "system/demo";

demoFile('feature/profile/profile-config');

const derived_comment = [
    {key: 1, from: 'a', text: 'I love this movie!'},
    {key: 2, from: 'a', text: "I love cats but Komodo dragons are cool too!\nThey are super cool!"}
];

feature('config_profile', {
    structureKey: 'profile',
    instanceKey: 'a',
    features: {
        config_profile: true,
        profileeditname: true
    },
    state: {
        globals: {
            initialized: true
        },
        collections: {
            derived_comment
        }
    }
}); 